import api from '@/api'

const namespaced = true

const state = {
  bargeStatuses: [],
  locations: [],
  tugboatPositions: [],
  tugboatData: [],
  tugboatFile: null,
  vesselTransactions: [],
  ports: []
}

const getters = {
  bargeStatuses: state => state.bargeStatuses,
  locations: state => state.locations,
  tugboatPositions: state => state.tugboatPositions,
  tugboatData: state => state.tugboatData,
  tugboatFile: state => state.tugboatFile,
  vesselTransactions: state => state.vesselTransactions,
  ports: state => state.ports
}

const mutations = {
  SET_BARGE_STATUSES: (state, payload) => {
    state.bargeStatuses = payload
  },
  SET_LOCATIONS: (state, payload) => {
    state.locations = payload
  },
  SET_TUGBOAT_LOCATIONS: (state, payload) => {
    state.tugboatPositions = payload
  },
  SET_TUGBOAT_DATA: (state, payload) => {
    state.tugboatData = payload
  },
  SET_TUGBOAT_FILE: (state, payload) => {
    state.tugboatFile = payload
  },
  SET_VESSEL_TRANSACTIONS: (state, payload) => {
    state.vesselTransactions = payload
  },
  SET_ROUTES: (state, payload) => {
    state.ports = payload
  }
}

const actions = {
  async fetchBargeStatuses({ commit }, payload) {
    try {
      const { data } = await api.getBargeStatus(payload)
      if (data.error) {
        commit('SET_BARGE_STATUSES', [])
        return
      }

      commit('SET_BARGE_STATUSES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchLocations({ commit }) {
    try {
      const { data } = await api.getPois()
      if (data.error) {
        commit('SET_LOCATIONS', [])
        return
      }

      commit('SET_LOCATIONS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getRoutes()
      if (data.error) {
        commit('SET_ROUTES', [])
        return
      }

      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTugboatPositions({ commit }, payload) {
    const { filter, isPopUp } = payload
    try {
      const { data } = await api.getPositions(filter)
      if (data.error) {
        commit(isPopUp ? 'SET_TUGBOAT_DATA' : 'SET_TUGBOAT_LOCATIONS', [])
        return
      }

      commit(isPopUp ? 'SET_TUGBOAT_DATA' : 'SET_TUGBOAT_LOCATIONS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchTugboatRoutes({ commit }, payload) {
    try {
      const { data } = await api.getTugboatRoutes(payload)
      if (data.error) {
        commit('SET_TUGBOAT_LOCATIONS', [])
        return
      }

      commit('SET_TUGBOAT_LOCATIONS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchVesselTransactions({ commit }, payload) {
    try {
      const { data } = await api.getVesselTransactions(payload)
      if (data.error) {
        commit('SET_VESSEL_TRANSACTIONS', [])
        return
      }

      commit('SET_VESSEL_TRANSACTIONS', data)
    } catch (err) {
      throw err
    }
  },
  async downloadFile({ commit }, payload) {
    try {
      const response = await api.downloadPositions(payload)
      if (response.data.error) {
        commit('SET_TUGBOAT_FILE', null)
        return
      }

      commit('SET_TUGBOAT_FILE', response)
    } catch (err) {
      throw err
    }
  },
  async downloadFileRoutes({ commit }, payload) {
    try {
      const response = await api.tugboatRoutesDownload(payload)
      if (response.data.error) {
        commit('SET_TUGBOAT_FILE', null)
        return
      }

      commit('SET_TUGBOAT_FILE', response)
    } catch (err) {
      throw err
    }
  },
  resetTugboatFile({ commit }) {
    commit('SET_TUGBOAT_FILE', null)
  }
}

export default { namespaced, state, getters, mutations, actions }
